import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService } from 'src/app/services/dhukan/cart.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {

  @Input() companyid: any = 0;
  @Input() tableno: any = null;
  @Input() dinetype: any = null;


  @Output() emitData = new EventEmitter();


  constructor(public cartservice: CartService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }


  fnInsertCustomerRequest(doctype) {
    var data = {
      'doctype': doctype,
      'dinetype': this.dinetype,
      'companyid': this.companyid,
      'tableno': this.tableno,
    }

    this.cartservice.fnInsertCustomerRequest(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {

            let _result = res.json().result;

            alert("Request Send..")

            this.activeModal.close(false);

          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })
  }


  fnClose() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    console.log(ex);
  }

}
